import { useState } from "react";
import styles from "./styles.module.scss";
import { ReportProjects } from "./Projects";
import { ReportCustomers } from "./Customers";
import { ReportPositions } from "./Positions";
import { ReportAreas } from "./Areas";
import { ReportResources } from "./Resources";
import { DefaultFilterReport } from "./components/DefaultFilter";
import dayjs from "dayjs";
import { ReportCostCenter } from "./CostCenter";
import { IReportMetricsRow } from "../../@types/reports-metrics.type";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

export type SelectedType = "resource" | "customer" | "project" | "area" | "position" | "costCenter";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, padding: 0 }}>{children} </Box>}
    </div>
  );
}

export const Reports: React.FC = () => {
  const [rowSelected, setRowSelected] =
    useState<IReportMetricsRow | null>(null);
  const [selectedType, setSelectedType] = 
    useState<SelectedType | null>(null);
  const [value, setValueTab] = useState(0);
  const [filterState, setFilterState] = useState({
    timeMode: 1,
    period: "Mensal",
    currentPeriod: dayjs(),
  });

  
  const clearFilterPerRow = () => {
    setRowSelected(null);
  };

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValueTab(newValue);
  };

  const handleFilterChange = (
    timeMode: number,
    period: string,
    currentPeriod: dayjs.Dayjs
  ) => {
    setFilterState({ timeMode, period, currentPeriod });
  };
  return (
    <>
      <div>
        <h1 className={styles.title}>Report das Alocações</h1>
      </div>
      <Box className={styles.customBox}>
        <Box className={styles.borderedBox}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            classes={{
              flexContainer: styles.customFlexContainer,
              indicator: styles["MuiTabs-indicator"],
            }}
          >
            <Tab
              label="Colaboradores"
              className={styles.tab}
              onClick={clearFilterPerRow}
            />
            <Tab
              label="Projetos"
              className={styles.tab}
              onClick={clearFilterPerRow}
            />
            <Tab
              label="Clientes"
              className={styles.tab}
              onClick={clearFilterPerRow}
            />
            <Tab
              label="Funções"
              className={styles.tab}
              onClick={clearFilterPerRow}
            />
            <Tab
              label="Áreas"
              className={styles.tab}
              onClick={clearFilterPerRow}
            />
            <Tab
              label="Centro de Custos"
              className={styles.tab}
              onClick={clearFilterPerRow}
            />
          </Tabs>
        </Box>
      </Box>
      <DefaultFilterReport
        rowSelected={rowSelected}
        onFilterChange={handleFilterChange}
        // tabName={getTabName()}
      />
      <CustomTabPanel value={value} index={0}>
        <ReportResources
            filterState={filterState}
            rowSelected={rowSelected}
            selectedType={selectedType}
            setRowSelected={setRowSelected}
            setSelectedType={setSelectedType}
            setValueTab={setValueTab}
            valueTab={value}
          />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ReportProjects
            filterState={filterState}
            rowSelected={rowSelected}
            selectedType={selectedType}
            setRowSelected={setRowSelected}
            setSelectedType={setSelectedType}
            setValueTab={setValueTab}
            valueTab={value}
          />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ReportCustomers
            filterState={filterState}
            selectedType={selectedType}
            setRowSelected={setRowSelected}
            setSelectedType={setSelectedType}
            setValueTab={setValueTab}
            valueTab={value}
          />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <ReportPositions
            filterState={filterState}
            selectedType={selectedType}
            setRowSelected={setRowSelected}
            setSelectedType={setSelectedType}
            setValueTab={setValueTab}
            valueTab={value}
          />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <ReportAreas
            filterState={filterState}
            selectedType={selectedType}
            setRowSelected={setRowSelected}
            setSelectedType={setSelectedType}
            setValueTab={setValueTab}
            valueTab={value}
          />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <ReportCostCenter
            filterState={filterState}
            selectedType={selectedType}
            setRowSelected={setRowSelected}
            setSelectedType={setSelectedType}
            setValueTab={setValueTab}
            valueTab={value}
          />
      </CustomTabPanel>
    </>
  );
};
